import { Group, Text } from "@mantine/core";
import { FunctionComponent } from "react";
import StarRating from "./StarRating";

interface ReviewSummaryProps {
  /** Average rating */
  averageRating: number;
  /** Total number of reviews */
  reviewCount: number;
}

export const ReviewSummary: FunctionComponent<ReviewSummaryProps> = ({
  averageRating,
  reviewCount,
}) => {
  if (reviewCount === 0) {
    return (
      <div>
        <Text c="dimmed" size="sm" mt="xs">
          No reviews yet. Be the first to review!
        </Text>
      </div>
    );
  }

  return (
    <div>
      <Group mt="xs" gap="md">
        <StarRating value={averageRating} count={reviewCount} size="md" />
        <Text size="xl" fw={600}>
          {averageRating.toFixed(1)}
        </Text>
      </Group>
    </div>
  );
};

export default ReviewSummary;
